/** Mirrors api/src/model.ts and the Guardian payloads the API passes through. */

export type StepId = 'entitlement' | 'connect' | 'site' | 'upload' | 'deploy'
  | 'permissions' | 'install' | 'verify' | 'azure' | 'complete';

export const STEP_ORDER: StepId[] = ['entitlement', 'connect', 'site', 'upload', 'deploy', 'permissions', 'install', 'verify', 'azure', 'complete'];

export const STEP_LABELS: Record<StepId, string> = {
  entitlement: 'Check licence in Guardian',
  connect:     'Customer Global Admin signs in',
  site:        'Prepare the SharePoint site',
  upload:      'Upload package to the app catalog',
  deploy:      'Deploy in the app catalog',
  permissions: 'Grant API permissions',
  install:     'Add the app to the site',
  verify:      'Verify the installation',
  azure:       'Azure backend (customer handoff)',
  complete:    'Complete',
};

/** Steps that act in the customer tenant and therefore need the GA's tokens. */
export const NEEDS_CUSTOMER: StepId[] = ['connect', 'site', 'upload', 'deploy', 'permissions', 'install', 'verify', 'azure'];

export type StepStatus = 'pending' | 'running' | 'done' | 'failed' | 'skipped';

export interface StepState { status: StepStatus; startedAt?: string; finishedAt?: string; message?: string; detail?: Record<string, unknown> }

export interface DeploymentSession {
  id: string; createdAt: string; updatedAt: string;
  status: 'active' | 'completed' | 'failed' | 'abandoned';
  createdBy: { objectId: string; name: string };
  lastActor?: { objectId: string; name: string };
  tenantId: string; customerName?: string;
  customerAdmin?: { username: string; signedInAt: string };
  sharePointHost?: string;
  productId: string; displayName: string; guardianAppId: string; version: string;
  siteUrl: string; siteTitle: string;
  catalogAppId?: string;
  steps: Record<StepId, StepState>;
}

export interface ProductManifest {
  schemaVersion: 2; productId: string; displayName: string; guardianAppId: string; version: string;
  package: { blobPath: string; fileName: string; solutionId: string; tenantWideDeploy: boolean };
  site: { defaultPath: string; defaultTitle: string };
  apiPermissions: Array<{ resource: string; scope: string }>;
  azure: { required: boolean; optional?: boolean; guideUrl?: string; packBlobPath?: string;
           outputs?: Array<{ key: string; label: string; help?: string }>; healthCheckPath?: string };
  packageUploaded?: boolean;
}

export interface GuardianInstallation {
  tenantId: string; appId: string; State: string; CustomerName: string | null; DeploymentId: string | null;
  Version: string | null; SiteUrl: string | null; UpdatedBy: string | null; LastError: string | null; StateChangedAt: string;
}

export interface Me { engineer: { objectId: string; name: string; username: string }; customerAppClientId: string }
